import { useEffect, useRef } from "react";
import { notify } from "@/lib/dashboard-v2/notify";

const MSG_TYPE = "editor-template-validation";

/**
 * Listens for legacy iframe preview validation messages and surfaces a non-blocking toast
 * in the parent dashboard window (Editor Pro remains unchanged).
 */
export function EditorTemplateValidationBridge() {
  const lastKey = useRef("");

  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.origin !== window.location.origin) return;
      if (e.data?.type !== MSG_TYPE) return;
      const count = Number(e.data?.payload?.count ?? 0);
      const page = typeof e.data?.payload?.page === "string" ? e.data.payload.page : "";
      if (!count) return;
      const key = `${count}:${page}:${e.data?.payload?.source ?? ""}`;
      if (key === lastKey.current) return;
      lastKey.current = key;
      notify.warning("Aperçu : anomalies de template", {
        description: `${count} problème(s) détecté(s)${page ? ` (page « ${page} »)` : ""}. L’aperçu reste affiché — voir la console pour le détail.`,
        duration: 10_000,
      });
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return null;
}
